import React, {useEffect, useMemo, useState} from 'react';

import {useUnit} from 'effector-react';
import debounce from 'lodash/debounce';
import {useTranslation} from 'react-i18next';

import {employeesModel, setCreateEmployeeModal} from '@/entities/eployersControl/model';
import {userModel} from '@/entities/user/model';
import {Button, ButtonVariant} from '@/shared/ui/Button';

import {Root} from './styled';

export const Control = () => {
    const employees = useUnit(employeesModel);
    const user = useUnit(userModel);
    const {t} = useTranslation();
    const [value, setValue] = useState(employees.state.search);

    useEffect(() => {
        setValue(employees.state.search);
    }, [employees.state.search]);

    const debouncedSearchChanged = useMemo(
        () =>
            debounce((nextValue: string, prevValue: string) => {
                if (nextValue !== prevValue) {
                    employees.searchChanged(nextValue);
                }
            }, 1000),
        [],
    );

    useEffect(() => {
        debouncedSearchChanged(value, employees.state.search);
        return debouncedSearchChanged.cancel;
    }, [value, employees.state.search]);

    const setButtonText = useMemo(() => {
        if (user.isDirector) {
            return t('create_employee.createEmployee');
        }
        if (user.isChiefInspector) {
            return t('create_employee.createInspector');
        }
        return t('create_employee.createInspector');
    }, [user, t]);

    return (
        <Root>
            <div style={{minWidth: 350, maxWidth: 700}}></div>
            <div>
                <Button variant={ButtonVariant.Normal} onClick={() => setCreateEmployeeModal(true)}>
                    {setButtonText}
                </Button>
            </div>
        </Root>
    );
};
